<template>
  <div class="ch-filtrate-box">
    <div class="ch-item" v-for="(item,index) in list" :key="index">
      <div class="ch-item-title">{{item.title}}</div>
      <div class="ch-item-value">
        <div class="ch-value-box">
          <div class="ch-value-item" v-for="(v_item,v_index) in item.value" :key="v_index">
            <div class="value" @click="onSelect(index,v_index)" :class="item.active==v_index?'active':''">{{v_item.label}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list:Array
  },
  methods:{
    onSelect(index,v_index){
      this.$emit('select',{index,v_index})
    }
  }
};
</script>

<style lang="less" scoped>
.ch-filtrate-box {
  > .ch-item {
    display: flex;
    padding: 15px 0;
    > .ch-item-title {
      font-size: 14px;
      color: #333333;
      font-weight: bold;
      width: 120px;
    }
    > .ch-item-value {
      flex: 1;
    }
  }
  > .ch-item + .ch-item {
    border-top: 1px solid #efefef;
  }
}
.ch-value-box {
  display: flex;
  flex-wrap: wrap;
  margin-top: -15px;
  margin-left: -30px;
  > .ch-value-item {
    padding-top: 15px;
    padding-left: 30px;
    > .value {
      height: 24px;
      line-height: 24px;
      padding: 0 5px;
      font-size: 14px;
      color: #666666;
      cursor:pointer;
    }
    > .value.active {
      background-color: #3984f7;
      color: #ffffff;
    }
  }
}
</style>